var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('news'),_c('br'),_c('articles'),_c('br'),_c('projects_home'),_c('br'),_c('photo_home'),_c('br'),_c('liveHome'),_c('pray_home'),_c('br'),_c('videos_home'),_c('br'),_c('br'),_c('apps_home'),_c('br'),_c('br'),_c('services_home2'),_c('br'),_c('pubHome'),_c('br'),_c('elist_home')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }